import { FormErrorMessage as _FormErrorMessage, FormControl as _FormControl, FormHelperText as _FormHelperText, FormLabel as _FormLabel } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
const FormControl = _FormControl;
const FormErrorMessage = _FormErrorMessage;
const FormHelperText = _FormHelperText;
const FormLabel = _FormLabel;
export const CUIFormControl = args => {
  return /*#__PURE__*/_jsx(FormControl, Object.assign({}, args));
};
export const CUIFormErrorMessage = args => {
  return /*#__PURE__*/_jsx(FormErrorMessage, Object.assign({}, args));
};
export const CUIFormHelperText = args => {
  return /*#__PURE__*/_jsx(FormHelperText, Object.assign({}, args));
};

/**
 *
 * Setting the fontSize here is necessary because Form parts are not
 * themeable: https://chakra-ui.com/docs/components/form-control/theming
 */
export const CUIFormLabel = args => {
  return /*#__PURE__*/_jsx(FormLabel, Object.assign({
    fontSize: "sm"
  }, args));
};